// extracted by mini-css-extract-plugin
module.exports = {"navTab":"navTab_navTab__2tbh6","navTabMobile":"navTab_navTabMobile__UBYsu"};